// extracted by mini-css-extract-plugin
module.exports = {"heading":"FooterSubscribe_heading__2wHlY","privacyText":"FooterSubscribe_privacyText__FK8S_"};